var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"modal-wrap"},[_c('div',{staticClass:"modal-conent"},[_vm._t("default",null,{"closeModal":_vm.closeModal})],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }